// extracted by mini-css-extract-plugin
export default {"bigAlert":"bigAlert__om1lrC","body":"body__w48IBb","text":"text__kwDZLq","header":"header__l4ZErj"};